import { Injectable } from '@angular/core';
import { ApiBaseOptions, ApiPostOptions, ApiService } from './api.service';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { ClinicFull, ClinicPayload, PatientPayload, PostNewPatient, PostNewPatientResp } from '../common.interface';
import { map } from 'rxjs/operators';
import { mapParams } from '../helpers';

@Injectable({
  providedIn: 'root',
})
export class ClinicsService {
  constructor(private apiService: ApiService) {
  }

  getAllClinics(params): Observable<ClinicPayload> {
    const options: ApiBaseOptions = {
      url: environment.apiUrls.clinicPrivate,
      withSpinner: true,
      queryParams: mapParams(params),
    };
    return this.apiService.get(options);
  }

  getClinicFullInfo(id: string): Observable<ClinicFull> {
    const options: ApiBaseOptions = {
      url: environment.apiUrls.clinicPrivate + id + '/',
      withSpinner: true,
      // queryParams: mapParams(params),
    };
    return this.apiService.get(options).pipe(
      map(r => {
        r.cliniAdmins = r.clinicUsers.filter(u => u.role === 'Clinic Admin');
        r.clinicOwner = r.clinicUsers.filter(u => u.role === 'Clinic Owner');
        r.clinicUsers = r.clinicUsers.filter(u => u.role === 'Clinic User');
        return r;
      }),
    );
  }

  getPatientsByClinic(params): Observable<PatientPayload> {
    const options: ApiBaseOptions = {
      url: environment.apiUrls.patientsPrivate,
      withSpinner: true,
      queryParams: mapParams(params),
    };
    return this.apiService.get(options);
  }

  updatePatient(id, params): Observable<PatientPayload> {
    const options: ApiPostOptions = {
      url: environment.apiUrls.patientsPrivate + id + '/',
      withSpinner: true,
      body: {
        ...params,
      },
    };
    return this.apiService.patch(options);
  }

  deletePatient(id): Observable<any> {
    const options: ApiBaseOptions = {
      url: environment.apiUrls.patientsPrivate + id + '/',
      withSpinner: true,
    };
    return this.apiService.delete(options);
  }

  updateClinic(props, id): Observable<any> {
    const options: ApiPostOptions = {
      url: environment.apiUrls.clinicPrivate + id + '/',
      withSpinner: true,
      body: props,
    };
    return this.apiService.patch(options);
  }

  deleteSimulation(id): Observable<any> {
    const options: ApiBaseOptions = {
      url: environment.apiUrls.simulations + id + '/',
      withSpinner: true,
    };
    return this.apiService.delete(options);
  }

  createLead(clinicData): Observable<any> {
    const options: ApiPostOptions = {
      url: environment.apiUrls.clinicLead,
      withSpinner: true,
      body: {
        ...clinicData,
      },
    };
    return this.apiService.post(options);
  }

  createPatient(patient: PostNewPatient): Observable<PostNewPatientResp> {
    const options: ApiPostOptions = {
      url: environment.apiUrls.patient,
      withSpinner: true,
      body: {
        ...patient,
      },
    };
    return this.apiService.post(options);
  }
}
